import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCheckCircle } = FiIcons;

const badges = ['SEO', 'Google Ads', 'Facebook Ads', 'Web Design', 'Email Marketing'];

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hero.webp"
          alt="Cleaning Service Marketing"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gray-900/75" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      </div>

      <div className="absolute top-1/3 right-16 w-72 h-72 bg-[#5a8f2a]/10 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-1/4 left-10 w-80 h-80 bg-[#5a8f2a]/8 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }} />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center mt-16">
        <motion.p
          className="text-[#5a8f2a] font-semibold text-sm uppercase tracking-widest mb-4"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Cleaning Service Marketing Agency
        </motion.p>

        <motion.h1
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }}
        >
          We Know{' '}
          <span className="text-[#5a8f2a]">What Works</span>
        </motion.h1>

        <motion.p
          className="text-xl md:text-2xl text-white font-semibold mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Get Found. Increase Your Leadflow. Increase Profits.
        </motion.p>

        <motion.p
          className="text-base md:text-lg text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45 }}
        >
          One Agency to fulfill your online marketing needs and know your business inside and out — utilizing SEO, Google Ads, Facebook, Web Design, and Email Marketing to grow your Cleaning Business.
        </motion.p>

        <motion.div
          className="flex flex-wrap items-center justify-center gap-2.5 mb-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          {badges.map((b) => (
            <span key={b} className="flex items-center gap-1.5 text-sm text-white bg-white/15 border border-white/30 rounded-full px-4 py-1.5 backdrop-blur-sm">
              <FiCheckCircle className="text-[#5a8f2a] text-xs" /> {b}
            </span>
          ))}
        </motion.div>

        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.75 }}
        >
          <a
            href="#strategy"
            className="group px-8 py-4 bg-[#5a8f2a] hover:bg-[#7ab535] text-white font-bold rounded-full transition-all shadow-2xl shadow-[#5a8f2a]/30 flex items-center gap-2 w-full sm:w-auto justify-center text-lg"
          >
            Start Here! <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#roadmap"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/50 text-white font-semibold rounded-full hover:bg-white/20 transition-all w-full sm:w-auto justify-center flex items-center"
          >
            See Our Road Map
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;